/**
 * 테이블 데이터 관련 Mixin
 * 테이블 데이터 설정 및 관리
 */
export default {
    methods: {
        async setupTable(data) {
            this.columns = [];
            this.rows = [];
            this.tails = [];
            this.handleRowData = [];

            if (this.currentNode.nodeType == "Root" || this.currentNode.nodeType == "System") {
                if (this.filterSystemType.sumAvail == "Y") {
                    this.columns = [
                        {
                            label: "노드명",
                            field: "text",
                            type: "text",
                        },
                        {
                            label: "집계값",
                            field: "value",
                            type: "text",
                            tdClass: "text-center font-weight-bold  text-dark",
                        },
                        {
                            label: "비중",
                            field: "sumRatio",
                            type: "text",
                        },
                    ];
                    data[0].children.forEach((item) => {
                        let row = {
                            text: item.text,
                            value:
                                item.sumVal > 1000
                                    ? `${item.sumVal._comma()} ${item.sumUnit}`
                                    : `${item.sumVal} ${item.sumUnit}`,
                            sumRatio: `${item.sumRatio} %`,
                            sumUnit: item.sumUnit,
                            sumVal: item.sumVal,
                        };
                        this.rows.push(row);
                    });
                } else {
                    this.columns = [
                        {
                            label: "상위 노드",
                            field: "groupKey",
                            type: "text",
                        },
                        {
                            label: "설비 ID",
                            field: "equipIdx",
                            type: "text",
                        },
                        {
                            label: "설비명",
                            field: "equipName",
                            type: "text",
                        },
                        {
                            label: "설비 유형",
                            field: "equipType",
                            type: "text",
                        },
                        {
                            label: "설비 사용 용도",
                            field: "equipUseType",
                            type: "text",
                        },
                        {
                            label: "구역",
                            field: "zoneIdx",
                            type: "text",
                            // tdClass: 'text-center font-weight-bold  text-dark',
                        },
                    ];
                    Object.keys(data).forEach((key) => {
                        data[key].equipStatus.forEach((status) => {
                            let row = {
                                groupKey: data[key].sysNodeName,
                                equipIdx: status.equipIdx,
                                equipName: status.equipName,
                                equipType: status.equipType,
                                equipUseType: status.equipUseType,
                                zoneIdx: status.zoneIdx,
                            };
                            this.rows.push(row);
                        });
                    });
                    /**
                     * - root, system 노드일 경우 설비 유형에 따라 테이블을 여러개 랜더링 하는 코드
                     * - 마운트 시점에 문제가 있어서 원복 후 추후 해결해서 반영할 예정
                     * - rows 데이터 구성해야함
                     */
                    // let tempColumns = [];
                    // let filterColumns = [];
                    // Object.keys(data).forEach(key => {
                    //     if (data[key].equipStatus[0].ioProps) {
                    //         let findType = this.equipTypeDetail.find(type => type.equipType == data[key].equipType);
                    //         tempColumns = data[key].equipStatus[0].ioProps.map(col => {
                    //             let prop = findType.ioProps.find(item => item.propCode == col.propCode)
                    //             if (prop) {
                    //                 const unit = this.$store.state.units.find(unit => unit.value == prop.unit)?.text;
                    //                 return { ...col, 'propName': prop.propName, 'unit': unit, 'enabled': prop.enabled };
                    //             } else {
                    //                 console.warn('Prop not found. ', col.propCode);
                    //             }
                    //         }).filter(item => item)
                    //     }
                    //     filterColumns.push(tempColumns);
                    // })
                    // filterColumns.forEach(item => {
                    //     let col = item.map(type => {
                    //         let label = type.unit ? `${type.propName}(${type.unit})` : type.propName;
                    //         return { label: label, field: type.propCode, type: 'text' }
                    //     })
                    //     this.columns.push(col);
                    // })
                }
            } else if (this.currentNode.nodeType == "Group") {
                // 단순 필터링에서 propName을 찾아 맵핑해야 함
                if (this.filterSystemType.sumAvail !== "Y") {
                    let filterColumns = [];
                    if (data[0]?.ioProps) {
                        filterColumns = data[0].ioProps.map((col) => {
                            let prop = this.equipTypeDetail.ioProps.find((item) => item.propCode == col.propCode);

                            if (prop) {
                                const unit = this.$store.state.units.find((unit) => unit.value == prop.unit)?.text;
                                return {
                                    ...col,
                                    propName: prop.propName,
                                    unit: unit,
                                    enabled: prop.enabled,
                                };
                            } else {
                                console.warn("Prop not found. ", col.propCode);
                            }
                        });
                    }

                    // Arrange undefined or null object
                    filterColumns = filterColumns.filter((item) => item);

                    this.handleRowData = data;

                    this.columns = [
                        {
                            label: "설비명",
                            field: "rowTitle",
                            type: "text",
                            compositionFields: ["equipName", "equipIdx"],
                        },
                    ];
                    filterColumns.forEach((prop) => {
                        let label = prop.unit ? `${prop.propName} (${prop.unit})` : prop.propName;
                        this.columns.push({
                            label: label,
                            field: prop.propCode,
                            type: "text",
                        });
                    });

                    this.columns.push({
                        label: "제어",
                        field: "ctrl",
                        tdClass: "text-center",
                        width: "70px",
                    });

                    this.handleColumns = [...this.columns];

                    data.forEach((item) => {
                        let row = {
                            equipIdx: item.equipIdx,
                            equipName: item.equipName,
                            ctrlMode: this.equipTypeDetail.ctrlModes.length > 0 ? true : false,
                        };
                        let tileView = {
                            equipIdx: item.equipIdx,
                            equipName: item.equipName,
                            icon: this.equipTypeDetail.icon,
                            dispColor: this.equipTypeDetail.dispColor,
                            checked: false,
                            ctrlMode: this.equipTypeDetail.ctrlModes.length > 0 ? true : false,
                            props: [],
                        };

                        item.ioProps.forEach((prop) => {
                            let find = this.equipTypeDetail.ioProps.find((item) => item.propCode == prop.propCode);
                            if (find) {
                                if (find.encodeType == "Enum") {
                                    if (find.encodeDesc) {
                                        row[prop.propCode] = JSON.parse(find.encodeDesc)[prop.ptVal];

                                        if (find.dispLevel < 3) {
                                            tileView.props.push({
                                                dispLevel: find.dispLevel,
                                                dispOrder: find.dispOrder,
                                                unit: find.unit ? find.unit : "",
                                                propName: find.propName,
                                                ptVal: JSON.parse(find.encodeDesc)[prop.ptVal],
                                            });
                                        }
                                    } else {
                                        row[prop.propCode] = prop.ptVal;

                                        if (find.dispLevel < 3) {
                                            tileView.props.push({
                                                dispLevel: find.dispLevel,
                                                dispOrder: find.dispOrder,
                                                unit: find.unit ? find.unit : "",
                                                propName: find.propName,
                                                ptVal: JSON.parse(find.encodeDesc)[prop.ptVal],
                                            });
                                        }
                                    }
                                } else if (find.encodeType == "Number") {
                                    row[prop.propCode] = prop.ptVal;

                                    if (find.dispLevel < 3) {
                                        tileView.props.push({
                                            dispLevel: find.dispLevel,
                                            dispOrder: find.dispOrder,
                                            unit: find.unit ? find.unit : "",
                                            propName: find.propName,
                                            ptVal: prop.ptVal,
                                        });
                                    }
                                } else if (find.encodeType == "None") {
                                    row[prop.propCode] = prop.ptVal;

                                    if (find.dispLevel < 3) {
                                        tileView.props.push({
                                            dispLevel: find.dispLevel,
                                            dispOrder: find.dispOrder,
                                            unit: find.unit ? find.unit : "",
                                            propName: find.propName,
                                            ptVal: prop.ptVal,
                                        });
                                    }
                                } else {
                                    row[prop.propCode] = prop.ptVal;

                                    if (find.dispLevel < 3) {
                                        tileView.props.push({
                                            dispLevel: find.dispLevel,
                                            dispOrder: find.dispOrder,
                                            unit: find.unit ? find.unit : "",
                                            propName: find.propName,
                                            ptVal: prop.ptVal,
                                        });
                                    }
                                }
                            } else row[prop.propCode] = prop.ptVal;
                        });
                        this.rows.push(row);
                        this.tails.push(tileView);
                    });
                } else {
                    this.columns = [
                        {
                            label: "노드명",
                            field: "text",
                            type: "text",
                        },
                        {
                            label: "집계값",
                            field: "value",
                            type: "text",
                            tdClass: "text-center font-weight-bold  text-dark",
                        },
                        {
                            label: "비중",
                            field: "sumRatio",
                            type: "text",
                        },
                    ];
                    if (!this.isEmpty(data[0])) {
                        data[0].children.forEach((item) => {
                            let row = {
                                text: item.text,
                                value:
                                    item.sumVal > 1000
                                        ? `${item.sumVal._comma()} ${item.sumUnit}`
                                        : `${item.sumVal} ${item.sumUnit}`,
                                sumRatio: `${item.sumRatio} %`,
                                sumUnit: item.sumUnit,
                                sumVal: item.sumVal,
                            };
                            this.rows.push(row);
                        });
                    }
                }
            } else if (this.currentNode.nodeType == "Equip") {
                if (this.filterSystemType.sumAvail !== "Y") {
                    this.columns = [
                        {
                            label: "관제점 ID",
                            field: "ptIdx",
                            width: "80px",
                            type: "text",
                            tdClass: "text-center font-weight-bold  text-dark",
                        },
                        {
                            label: "설비 항목",
                            field: "propName",
                            width: "100px",
                            type: "text",
                        },
                        {
                            label: "계측 유형",
                            field: "dataSourceType",
                            width: "80px",
                            type: "text",
                        },
                        {
                            label: "I/O",
                            field: "ioType",
                            width: "60px",
                            type: "text",
                        },
                        {
                            label: "현재값",
                            field: "ptVal",
                            width: "120px",
                            type: "text",
                            tdClass: "text-center font-weight-bold  text-dark",
                        },
                        {
                            label: "제어 설정",
                            field: "property",
                            type: "text",
                        },
                        {
                            label: "설명",
                            field: "description",
                            width: "30rem",
                            type: "text",
                        },
                    ];

                    this.handleColumns = [...this.columns];

                    const dataSourceType = this.$store.state.commonCodes.dataSourceType;
                    data[0].ioProps &&
                        data[0].ioProps.forEach((prop) => {
                            let find = this.equipTypeDetail.ioProps.find((item) => item.propCode == prop.propCode);
                            let row;
                            if (find) {
                                row = {
                                    ioType: find.ioType ? find.ioType : "-",
                                    propType: "Io",
                                    propName: find.propName ? find.propName : "-",
                                    dataSourceType: find.dataSourceType
                                        ? dataSourceType.find((type) => type.value == find.dataSourceType).text
                                        : "-",
                                    ctrlMode: this.equipTypeDetail.ctrlModes.length > 0 ? true : false,
                                    encodeType: find.encodeType ? find.encodeType : null,
                                    encodeDesc: find.encodeDesc ? find.encodeDesc : null,
                                    propCode: find.propCode ? find.propCode : null,
                                    description: find.description,
                                    selectProp: prop.ptVal,
                                    ptIdx: prop.ptIdx ?? null,
                                };

                                const unit = this.$store.state.units.find((unit) => unit.value == find.unit)?.text;

                                if (find.encodeType == "Enum") {
                                    if (find.encodeDesc) row.ptVal = JSON.parse(find.encodeDesc)[prop.ptVal];
                                    else row.ptVal = prop.ptVal;
                                } else if (find.encodeType == "Number") {
                                    row.ptVal = unit ? `${prop.ptVal ?? "-"} ${unit ?? "-"}` : prop.ptVal;
                                } else {
                                    row.ptVal = unit ? `${prop.ptVal ?? "-"} ${unit ?? "-"}` : prop.ptVal;
                                }

                                this.rows.push(row);
                            }
                        });

                    data[0].calcProps &&
                        data[0].calcProps.forEach((prop) => {
                            let find = this.equipTypeDetail.calcProps.find((item) => item.propCode == prop.propCode);
                            let row;
                            if (find) {
                                row = {
                                    ioType: find.ioType ? find.ioType : "-",
                                    propType: "Calc",
                                    propName: find.propName ? find.propName : "-",
                                    dataSourceType: find.dataSourceType
                                        ? dataSourceType.find((type) => type.value == find.dataSourceType).text
                                        : "-",
                                    ctrlMode: this.equipTypeDetail.ctrlModes.length > 0 ? true : false,
                                    encodeType: find.encodeType ? find.encodeType : null,
                                    encodeDesc: find.encodeDesc ? find.encodeDesc : null,
                                    propCode: find.propCode ? find.propCode : null,
                                    description: find.description ? find.description : "-",
                                    ptIdx: prop.ptIdx ?? null,
                                };
                                if (find.encodeDesc) {
                                    row.ptVal = JSON.parse(find.encodeDesc)[prop.ptVal];
                                } else {
                                    row.ptVal = prop.ptVal;
                                }
                                this.rows.push(row);
                            }
                        });

                    data[0].userProps &&
                        data[0].userProps.forEach((prop) => {
                            let find = this.equipTypeDetail.userProps.find((item) => item.propCode == prop.propCode);
                            let row;
                            if (find) {
                                row = {
                                    ioType: find.ioType ? find.ioType : "-",
                                    propType: "User",
                                    propName: find.propName ? find.propName : "-",
                                    dataSourceType: find.dataSourceType
                                        ? dataSourceType.find((type) => type.value == find.dataSourceType).text
                                        : "-",
                                    ctrlMode: this.equipTypeDetail.ctrlModes.length > 0 ? true : false,
                                    encodeType: find.encodeType ? find.encodeType : null,
                                    encodeDesc: find.encodeDesc ? find.encodeDesc : null,
                                    propCode: find.propCode ? find.propCode : null,
                                    description: find.description ? find.description : "-",
                                    ptIdx: prop.ptIdx ?? null,
                                    ptVal: prop.ptVal ?? null,
                                };
                                this.rows.push(row);
                            }
                        });
                } else {
                    this.columns = [
                        {
                            label: "관제점",
                            field: "ptIdx",
                            type: "text",
                            width: "60px",
                        },
                        {
                            label: "관제점 명",
                            field: "ptName",
                            type: "text",
                            width: "150px",
                        },
                        {
                            label: "집계값",
                            field: "ptVal",
                            type: "text",
                            tdClass: "text-center font-weight-bold  text-dark",
                        },
                        {
                            label: "비중",
                            field: "ptRatio",
                            type: "text",
                            tdClass: "text-center font-weight-bold  text-dark",
                        },
                    ];
                    try {
                        // 설비노드인 경우 this.equipStatusData.children은 설비노드의 ptMaps의 현재값과 집계값이 저장되어 있음.
                        // 하나의 설비노드가 여러개의 설비와 연결되는 경우는 현재 없기 때문에 equipStatusData는 최대 1개.
                        const ptMaps = this.equipStatusData[0]?.children ?? null;

                        if (ptMaps) {
                            let sum = ptMaps.reduce((acc, pt) => acc + pt.ptVal, 0);

                            ptMaps
                                .sort((a, b) => b.ptVal - a.ptVal)
                                .forEach((item) => {
                                    let ptRatio = (item.ptVal / sum) * 100;
                                    ptRatio = Number(ptRatio.toFixed(1));

                                    let row = {
                                        ptIdx: item.ptIdx,
                                        ptName: item.text,
                                        ptVal: (item.ptVal > 1000 ? item.ptVal._comma() : item.ptVal) + item.unit,
                                        ptRatio: ptRatio + "%",
                                        unitType: item.unitType,
                                        unit: item.unit,
                                    };

                                    this.rows.push(row);
                                });
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            } else {
                this.columns = [];
                this.rows = [];
            }
        },
    },
};
